
import { useImpersonationState } from "./useImpersonationState";
import { useImpersonationActions } from "./useImpersonationActions";
import { useImpersonationInitializer } from "./useImpersonationInitializer";

export const useImpersonation = () => {
  const {
    isImpersonating,
    setIsImpersonating,
    originalUser,
    setOriginalUser
  } = useImpersonationState();

  const {
    impersonateUser,
    stopImpersonating
  } = useImpersonationActions(setIsImpersonating, setOriginalUser, originalUser);

  const {
    initializeImpersonation
  } = useImpersonationInitializer(setIsImpersonating, setOriginalUser);

  return {
    // State
    isImpersonating,
    originalUser,
    
    // Actions
    impersonateUser,
    stopImpersonating,
    
    // Initialization
    initializeImpersonation
  };
};
